import config from "appConfig";

const walls = {
  "1": {
    imageUrl: `${config.ASSETS_URL}/01/18/principle/walls/1.svg`,
    equationImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-1.svg`,
    equationSmallImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-sub-1.svg`,
  },
  "2": {
    imageUrl: `${config.ASSETS_URL}/01/18/principle/walls/2.svg`,
    equationImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-2.svg`,
    equationSmallImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-sub-1.svg`,
  },
  "3": {
    imageUrl: `${config.ASSETS_URL}/01/18/principle/walls/3.svg`,
    equationImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-3.svg`,
    equationSmallImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-sub-1.svg`,
  },
  "4": {
    imageUrl: `${config.ASSETS_URL}/01/18/principle/walls/4.svg`,
    equationImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-4.svg`,
    equationSmallImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-sub-1.svg`,
  },
  "5": {
    imageUrl: `${config.ASSETS_URL}/01/18/principle/walls/5.svg`,
    equationImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-5.svg`,
    equationSmallImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-sub-1.svg`,
  },
  "6": {
    imageUrl: `${config.ASSETS_URL}/01/18/principle/walls/6.svg`,
    equationImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-6.svg`,
    equationSmallImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-sub-1.svg`,
  },
};

export default walls;
